// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

interface InitialStateProps {
  registerCurrUser?: any;
  loading?: boolean;
  error?: string | null;
  resendEmailUser?: string | null;
  userForgetPassword?: string | null;
  resetPassword?: string | null;
}

type availeabilityProps = {
  userId: string;
};

type UserInfoPros = {
  id: string;
  firstName: string;
  lastName: string;
  state: string;
  zipcode: string;
  address: string;
};
const initialState: InitialStateProps = {
  registerCurrUser: [],
  loading: false,
  error: null,
  resendEmailUser: null,
  userForgetPassword: null,
  resetPassword: null,
};

// register User API Calling
export const registerUserAPI = createAsyncThunk(
  'auth/registerUser',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.register, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Resend Email API Calling
export const resendEmailAPI = createAsyncThunk(
  'auth/resendEmail',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.resendEmail, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Forget Password API Calling
export const forgetPasswordAPI = createAsyncThunk(
  'auth/forgetPassword',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.forgetPassword, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Reset Password API Calling
export const resetPasswordAPI = createAsyncThunk(
  'auth/resetPassword',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.resetPassword, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Suspend Account API Calling
export const suspendUserAPI = createAsyncThunk(
  'auth/suspendUser',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.suspendUser, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Suspend Account API Calling
export const unSuspendUserAPI = createAsyncThunk(
  'auth/unsuspendUser',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.unsuspendUser, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Delete  User API Calling
export const deleteUserAPI = createAsyncThunk(
  'auth/deleteUser',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.deleteUser, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Delete  User API Calling
export const getStripeLink = createAsyncThunk(
  'auth/stripe',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.stripeLink, {
        ...values,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// User Availability API Calling
export const checkUserAvailability = createAsyncThunk(
  'auth/userAvailability',
  async (params: availeabilityProps, { rejectWithValue }) => {
    try {
      const { userId } = params;
      let endPoint = endPoints.userAvailability;
      if (userId) {
        endPoint = `${endPoints.userAvailability}/?userId=${userId}`;
      }
      const { data } = await axiosInstance.get(endPoint);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// User Availability API Calling
export const updateUserInfo = createAsyncThunk(
  'auth/userinfo',
  async (params: UserInfoPros, { rejectWithValue }) => {
    try {
      let endPoint = `${endPoints.profile}/${params.id}`;
      const { data } = await axiosInstance.put(endPoint, {
        ...params,
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Auth Slices
export const authUserSlice = createSlice({
  name: 'auth/registerUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerUserAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUserAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.registerCurrUser = action.payload;
        state.error = null;
      })
      .addCase(registerUserAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(resendEmailAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resendEmailAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.resendEmailUser = action.payload;
        state.error = null;
      })
      .addCase(resendEmailAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(forgetPasswordAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgetPasswordAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.userForgetPassword = action.payload;
        state.error = null;
      })
      .addCase(forgetPasswordAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(resetPasswordAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPasswordAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.resetPassword = action.payload;
        state.error = null;
      })
      .addCase(resetPasswordAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(suspendUserAPI.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(suspendUserAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(suspendUserAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteUserAPI.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUserAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteUserAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(unSuspendUserAPI.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(unSuspendUserAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(unSuspendUserAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getStripeLink.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStripeLink.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getStripeLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(checkUserAvailability.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkUserAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(checkUserAvailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateUserInfo.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Action creators are generated for each case reducer function
// export const {  } = authUserSlice.actions;

export default authUserSlice.reducer;
